import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatient(patientId, options) {
    return useQuery(['patient', patientId], () => PESService.get(patientId), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        cacheTime: 2 * (60 * 1000), // two minutes
        ...options,
    });
}

export default useFetchPatient;
